/**
 * Space & Window Commands — central barrel export
 *
 * All space/window-related commands live here. Imported once by commandRegistryStore.
 *
 * Files:
 *   spaceLifecycle.ts    — space_create, space_switch, space_list
 *   windowManagement.ts  — space_open_window, space_close_window, space_createWindow,
 *                          space_updateWindow, space_removeWindow,
 *                          space_list_windows, space_focus_window, space_openEntity
 *   panelVisibility.ts   — space_open_sidebar, space_close_sidebar, space_toggle_sidebar,
 *                          space_open_chat, space_close_chat, space_toggle_chat
 *   sidebarTree.ts       — sidebar_expandAllFolders, sidebar_collapseAllFolders
 *   workflowUtilities.ts — space_findWindowByEntity, workflow_sendMessage,
 *                          workflow_generateSchoolTable
 */

export { spaceLifecycleCommands } from './spaceLifecycle';
export { windowManagementCommands } from './windowManagement';
export { panelVisibilityCommands } from './panelVisibility';
export { sidebarTreeCommands } from './sidebarTree';
export { workflowUtilityCommands } from './workflowUtilities';
export { pageScrollCommands } from './pageScrollCommand';
